export default "__VITE_ASSET__f5aff349__"